import { render, staticRenderFns } from "./authors.vue?vue&type=template&id=0aa64bce"
import script from "./authors.vue?vue&type=script&lang=js"
export * from "./authors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports